/* ============================================================
   DIETMONSTA · Cart

   Removing a pack means zeroing every line item that belongs to it, so
   one click sends all of that group's line keys in a single
   /cart/update.js request.
   ============================================================ */

class DMCart extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-dm-remove]');
      if (btn) this.#remove(btn);
    });
  }

  async #remove(btn) {
    const keys = (btn.dataset.dmRemove || '').split(',').filter(Boolean);
    if (keys.length === 0) return;

    btn.disabled = true;

    // One request for the whole group. Removing keys one at a time would
    // re-index the cart between calls and can drop the wrong line.
    const updates = {};
    keys.forEach((k) => {
      updates[k] = 0;
    });

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error('update_failed');
      window.location.reload();
    } catch {
      btn.disabled = false;
    }
  }
}

if (!customElements.get('dm-cart')) {
  customElements.define('dm-cart', DMCart);
}
